import { Component, inject } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { Utils } from 'src/modules/utils/shared/utils';
import { EnaioCertificateService } from '../../services/enaio-certificate.service';
import { EnaioCertificatesTools } from '../../shared/enaio-certificates-tools';
import { SchoolClass } from '../../shared/school-class.model';
import { SchoolType } from '../../shared/school-type.enum';

@Component({
    selector: 'app-covid-tests-main',
    templateUrl: './covid-tests-main.component.html',
    styleUrls: ['./covid-tests-main.component.scss']
})
export class CovidTestsMainComponent extends ComponentView {

    service = inject(EnaioCertificateService);

    _SchoolType = SchoolType;

    schoolClasses: SchoolClass[] = [];
    year: number;
    isHalfYear: boolean;
    isClassRegisterEditor = false;
    isSecretary = false;

    async initParams(): Promise<boolean> {
        this.year = EnaioCertificatesTools.getCurrentYear();
        this.isHalfYear = EnaioCertificatesTools.getCurrentIsHalfYear();
        this.isClassRegisterEditor = this.service.isClassRegisterEditor();
        this.isSecretary = this.service.isSecretary();
        this.schoolClasses = await this.service.restGetSchoolClasses(EnaioCertificatesTools.getCurrentSchoolYear());
        this.app.updateNavigation("Corona Testungen", [this.service.getHomeCovidTests()]);
        return true;
    }

    getExistingGrades(): number[] {
        return Utils.arrayGetUnique(this.schoolClasses.map(sc => sc.grade));
    }

    async analysesClick(): Promise<void> {
        await this.app.navigate(["/enaio-certificates", "covid-tests", "analyses"]);
    }


}
